import React, { FC } from 'react';

import styled from 'styled-components';

import { PlatformBuy } from '@redux/reducers/profile/types';

import { Col } from '../atoms/Grid';
import Image from '../atoms/Image/Image';
import Text from '../atoms/Text/Text';

type AvailablePlatformProps = Partial<PlatformBuy>;

const AvailablePlatform: FC<AvailablePlatformProps> = ({ icon, name }) => {
  return (
    <ColExtended xs={4}>
      <Image height="55px" src={icon} />
      <Text lineHeight={1.8} size={0.875} color="cornflowerBlue">
        {name}
      </Text>
    </ColExtended>
  );
};

const ColExtended = styled(Col)`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

export default AvailablePlatform;
